import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Step.css";
import ufo from "../../../../assets/CalibrationGame/ufo.png";
import energyRing from "../../../../assets/CalibrationGame/ring.svg"
import pointer from "../../../../assets/CalibrationGame/pointer.svg";
import UFOMotion from "../../UFOFlyEffect/UFOMotion";

const Step = () => {
    const [step, setStep] = useState(1);
    const [startAnimation, setStartAnimation] = useState(false);
    const [display, setDisplay] = useState({ 1: true, 9: true });
    const navigate = useNavigate();

    const handleStop = () => {
        setStartAnimation(false);
        if (step == 1) {
            setStep(2)
        } else if (step == 8) {
            setStep(9)
        }
    }


    return (

        <>

            {
                step == 1 ?
                    (
                        <>
                            <div className='container' id='instruction-text-div-1' style={{ display: display['1'] ? "block" : "none" }}>
                                <div className='row'><p id='instruction-text' >Follow the UFO, it’ll fly to different sections of the screen.<br /> </p></div>
                                <div className='row text-end'><p id='instruction-text' style={{ color: "#0077CC", marginTop: "0px", cursor: "pointer" }} onClick={() => { setDisplay({ ...display, "1": false }); setStartAnimation(true); }}>Next<br /> </p></div>
                            </div>
                            <UFOMotion start={{ x: (75 * window.innerHeight)/100, y: (35.68 * window.innerWidth)/100 }} end={{ x: ( 92.31 * window.innerWidth )/100, y: (88 * window.innerHeight )/100 }} setStartAnimation={null} shouldStart={startAnimation} onStop={handleStop} turns={7} />
                        </>
                    )
                    :
                    step == 2 ?
                        (
                            <>
                                <div className='container' id='instruction-text-div-2'>
                                    <div className='row'><p id='instruction-text'>There will be hidden traps to trap the UFO.<br /> </p></div>
                                    <div className='row text-end'><p id='instruction-text' style={{ color: "#0077CC", marginTop: "0px", cursor: "pointer" }} onClick={() => { setStep(3); setStartAnimation(false); }}>Next<br /> </p></div>
                                </div>
                                <img src={ufo} alt="" id='ufo-img-trapped'/>
                                <img src={energyRing} id="ufo-energy-ring" />
                                <div id='trapped-circle-step-2'></div>
                            </>
                        )
                        :

                        step == 3 ?
                            (
                                <>
                                    <div className='container' id='instruction-text-div-3'>
                                        <div className='row'><p id='instruction-text'>When the UFO gets trapped in any of the traps, You'll have to click on the trap three times to free the UFO.<br /> </p></div>
                                        <div className='row text-end'><p id='instruction-text' style={{ color: "#0077CC", marginTop: "0px", cursor: "pointer" }} onClick={() => { setStep(4) }}>Next<br /> </p></div>
                                    </div>
                                    <img src={ufo} alt="" id='ufo-img-trapped' width="100px" />
                                    <img src={energyRing} id="ufo-energy-ring" width="145px" />
                                    <div id='trapped-circle-step-2'></div>
                                </>
                            )
                            :
                            step == 4 ?
                                (
                                    <>
                                        <div className='container' id='instruction-text-div-4'>
                                            <div className='row'><p id='instruction-text'>Click on the trap 3 times.<br /> </p></div>
                                        </div>
                                        <img src={ufo} alt="" id='ufo-img-trapped' />
                                        <img src={energyRing} id="ufo-energy-ring" width="145px" />
                                        <div id='trapped-circle-step-2' style={{ cursor: "pointer" }} onClick={() => { setStep(5) }}></div>
                                    </>
                                )
                                :
                                step == 5 ?
                                    (
                                        <>
                                            <div className='container' id='instruction-text-div-4'>
                                                <div className='row'><p id='instruction-text'>Click on the trap 2 times.<br /> </p></div>
                                            </div>
                                            <img src={ufo} alt="" id='ufo-img-trapped' />
                                            <img src={energyRing} id="ufo-energy-ring" width="145px" />
                                            <div id='trapped-circle-3' style={{ cursor: "pointer" }} onClick={() => { setStep(6) }}></div>
                                        </>
                                    )
                                    :
                                    step == 6 ?
                                        (
                                            <>
                                                <div className='container' id='instruction-text-div-4'>
                                                    <div className='row'><p id='instruction-text'>Click on the trap 1 times.<br /> </p></div>
                                                </div>
                                                <img src={ufo} alt="" id='ufo-img-trapped' />
                                                <img src={energyRing} id="ufo-energy-ring" width="145px" />
                                                <div id='trapped-circle-4' style={{ cursor: "pointer" }} onClick={() => { setStep(7) }}></div>
                                            </>
                                        )
                                        :
                                        step == 7 ?
                                            (
                                                <>
                                                    <div className='container' id='instruction-text-div-5'>
                                                        <div className='row'><p id='instruction-text'>Great you just helped to get the UFO free!<br /> </p></div>
                                                        <div className='row text-end'><p id='instruction-text' style={{ color: "#0077CC", marginTop: "0px", cursor: "pointer" }} onClick={() => { setStep(8) }}>Next<br /> </p></div>
                                                    </div>
                                                    <img src={ufo} alt="" id='ufo-img-trapped' />
                                                </>
                                            )
                                            :
                                            step == 8 ?
                                                (
                                                    <>
                                                        <div className='container' id='instruction-text-div-6' style={{ display: display['9'] ? "block" : "none" }}>
                                                            <div className='row'><p id='instruction-text'>Now the UFO is free to fly<br /> </p></div>
                                                            <div className='row text-end'><p id='instruction-text' style={{ color: "#0077CC", marginTop: "0px", cursor: "pointer" }} onClick={() => { setDisplay({ ...display, "9": false }); setStartAnimation(true); }}>Next<br /> </p></div>
                                                        </div>
                                                        <UFOMotion start={{ x: (92.31 * window.innerWidth)/100, y: (88 * window.innerHeight )/100 }} end={{ x: (39.73 * window.innerWidth)/100, y: (30.38* window.innerHeight)/100 }} setStartAnimation={null} shouldStart={startAnimation} onStop={handleStop} turns={7} />
                                                    </>
                                                )
                                                :
                                                step == 9 ?
                                                    (
                                                        <>

                                                            <div className='container' id='instruction-text-div-7'>
                                                                <div className='row'><p id='instruction-text'>When the UFO flies to another place, another trap catches it. Help the UFO get free by clicking 3 times on the trap to free the UFO.<br /> </p></div>
                                                                <div className='row text-end'><p id='instruction-text' style={{ color: "#0077CC", marginTop: "0px", cursor: "pointer" }} onClick={() => { setStep(10) }}>Next<br /> </p></div>
                                                            </div>
                                                            <img src={ufo} alt="" id='ufo-img-trapped-3' />
                                                            <div id='trapped-circle-2'></div>
                                                            <img src={energyRing} id="ufo-energy-ring-2" />
                                                            <img src={pointer} alt="" id='finger-pointer' />


                                                        </>
                                                    )
                                                    :
                                                    step == 10 ?
                                                        (
                                                            <>
                                                                <div className='container' id='instruction-text-div-8'>
                                                                    <div className='row'><p id='instruction-text'>There are total 13 traps hidden in this space. Help the UFO to go through each and every trap.<br /> </p></div>
                                                                    <div className='row text-end'><p id='instruction-text' style={{ color: "#0077CC", marginTop: "0px", cursor: "pointer" }} onClick={() => { navigate("/calibration/start") }}>Done!<br /> </p></div>
                                                                </div>
                                                                <img src={ufo} alt="" id='ufo-img-trapped-3' />
                                                            </>
                                                        )
                                                        :
                                                        <></>

            }

        </>

    )
}


export default Step;
